module.exports = __webpack_public_path__ + "img/ilearningtips.57ea6f86.png";